<div class="confirm-dialog" fxLayout="column" fxLayoutGap="14px">
  @if (data?.title) {
    <div class="confirm-dialog__content confirm-dialog__content--titled" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="16px">
      <div class="confirm-dialog__icon" fxLayout="row" fxLayoutAlign="center center">
        <mat-icon>warning</mat-icon>
      </div>
      <div class="confirm-dialog__copy" fxLayout="column" fxLayoutGap="6px">
        <div class="confirm-dialog__title">{{ data?.title }}</div>
        <div class="confirm-dialog__message">{{ data?.message }}</div>
      </div>
    </div>
  } @else {
    <div class="confirm-dialog__content" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="8px">
      <div class="confirm-dialog__message">{{ data?.message }}</div>
    </div>
  }

  <div class="confirm-dialog__actions" fxLayout="row" fxLayout.lt-sm="column-reverse"
       fxLayoutAlign="center center" fxLayoutAlign.lt-sm="center stretch"
       fxLayoutGap="10px" fxLayoutGap.lt-sm="8px">
    @if (data?.confirmationRequired) {
      <button mat-stroked-button type="button" class="confirm-dialog__button btn-outline-accent" (click)="onDismiss()">NO</button>
      <button mat-raised-button type="button" color="primary" class="confirm-dialog__button btn-dark" (click)="onConfirm()">YES</button>
    } @else {
      <button mat-raised-button type="button" color="primary" class="confirm-dialog__button btn-dark" (click)="onConfirm()">OK</button>
    }
  </div>
</div>
